import { type InspectionCompany, useApiInspectionsV1CompaniesList } from 'api';
import { useToggle } from 'features';
import { useTranslation } from 'i18n';
import { useMemo, useState } from 'react';
import { Button, DataGrid, Drawer, Page, Section } from 'ui';

import { CompanyAndInspectorCreate } from '../../components';
import { getColumns } from './columns';
export const InspectionCompanyList = () => {
  const { t } = useTranslation('orders');
  const { data, isLoading } = useApiInspectionsV1CompaniesList();

  const { open, isOpen, close } = useToggle();
  const [selectedCompany, setSelectedCompany] = useState<InspectionCompany | null>(null);
  const columns = useMemo(() => getColumns(t), [t]);

  return (
    <Page>
      <Drawer open={isOpen} anchor="right">
        <CompanyAndInspectorCreate
          key={selectedCompany ? selectedCompany.id : null} // different components at same position state reset https://react.dev/learn/preserving-and-resetting-state#different-components-at-the-same-position-reset-state
          onClose={close}
          company={selectedCompany}
        />
      </Drawer>
      <Section
        title={t('inspectionCompany.sectionTitles.inspectionCompanies')}
        action={
          <Button
            onClick={() => {
              setSelectedCompany(null);
              open();
            }}
          >
            {t('inspectionCompany.actions.createCompany')}
          </Button>
        }
      >
        <DataGrid<InspectionCompany>
          rows={data?.results ?? []}
          loading={isLoading}
          disableColumnMenu
          autoHeight
          columns={columns}
          showColumnVerticalBorder
          showCellVerticalBorder
          onRowClick={(params) => {
            setSelectedCompany(params.row);
            open();
          }}
        />
      </Section>
    </Page>
  );
};
